module.exports = __webpack_public_path__ + "img/groups.05baa74c.svg";